import { EquipmentStructureType } from '../types/EquipmentTypes';
import automation from './equipmentStructure/automation';
import bridgeEquipment from './equipmentStructure/bridgeEquipment';
import cargoHandling from './equipmentStructure/cargoHandling';
import electricalElectronic from './equipmentStructure/electricalElectronic';
import fifi from './equipmentStructure/fifi';
import hull from './equipmentStructure/hull';
import hullOutfitting from './equipmentStructure/hullOutfitting';
import machineryEquipment from './equipmentStructure/machineryEquipment';
import regulatory from './equipmentStructure/regulatory';

const equipmentStructure: EquipmentStructureType[] = [
  hull,
  hullOutfitting,
  cargoHandling,
  machineryEquipment,
  automation,
  fifi,
  electricalElectronic,
  bridgeEquipment,
  regulatory,
];

export default equipmentStructure;
